import { render, staticRenderFns } from "./SupplierPriceComponent.vue?vue&type=template&id=2468a672&scoped=true&"
import script from "./SupplierPriceComponent.vue?vue&type=script&lang=js&"
export * from "./SupplierPriceComponent.vue?vue&type=script&lang=js&"
import style0 from "./SupplierPriceComponent.vue?vue&type=style&index=0&id=2468a672&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2468a672",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
